import { RVIcon } from "../../../../atoms/RVIcon/RVIcon";

import styles from "./RVHelpPopupPresetButton.module.scss";

export type RVHelpPopupPresetButtonProps = {
    /** Short suggestion text displayed inside the chip. */
    label: string;
    /** Called when the user clicks the chip. */
    onClick: () => void;
};

/**
 * A clickable preset-prompt chip rendered inside `RVHelpPopup`.
 * Displays a short suggestion label with a trailing arrow icon;
 * clicking it fires `onClick` so the parent can submit the prompt
 * directly without the user having to type anything.
 *
 * @example
 * <RVHelpPopupPresetButton label="What does this agent do?" onClick={handlePrompt} />
 */
export function RVHelpPopupPresetButton({ label, onClick }: RVHelpPopupPresetButtonProps): JSX.Element {
    return (
        <button type="button" className={styles.presetButton} onClick={onClick}>
            <span className={styles.presetButtonText}>{label}</span>
            <RVIcon icon="arrow-right" size="xsmall" className={styles.presetButtonChevron} />
        </button>
    );
}
